// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xj_a bhe_a bhe_x","StrollerDetailRating__muted":"xj_b bhe_fm"};